import React from 'react';
import DoliDanaVisual from './Visuals/DoliDana/index.jsx';
import Teen62Visual from './Visuals/Teen62/index.jsx';
import MogamboVisual from './Visuals/Mogambo/index.jsx';
import SuperOverVisual from './Visuals/SuperOver/index.jsx';
import SicboVisual from './Visuals/Sicbo/index.jsx';
import PokerVisual from './Visuals/Poker/index.jsx';
import PoisonVisual from './Visuals/Poison/index.jsx';
import JokerVisual from './Visuals/Joker/index.jsx';

const ResultVisuals = ({ gameType, data, poisonCard, playerA, playerB }) => {
    // Normalize game type
    const normalizedType = gameType?.toLowerCase();

    switch (normalizedType) {
        case 'dolidana':
            return <DoliDanaVisual data={data} />;
        case 'teen62':
        case 'teenpatti62': // Handle variations
        case 'teen20c':
        case 'teen41':
        case 'teen42':
        case 'teen33':
        case 'teen32':
        case 'teen':
        case 'teen20':
        case 'teen9':
        case 'teen8':
            return <Teen62Visual data={data} />;
        case 'poker':
        case 'poker20':
        case 'poker6':
            return <PokerVisual data={data} />;
        case 'mogambo':
            return <MogamboVisual data={data} />;
        case 'superover':
        case 'superover2':
        case 'superover3':
            return <SuperOverVisual data={data} />;
        case 'sicbo':
        case 'sicbo2':
            return <SicboVisual data={data} />;
        case 'poison':
        case 'poison20':
            return <PoisonVisual data={data} poisonCard={poisonCard} playerA={playerA} playerB={playerB} />;
        case 'joker20':
        case 'teenjoker':
            return <JokerVisual data={data} poisonCard={poisonCard} playerA={playerA} playerB={playerB} />;
        default:
            // Fallback or empty if game not supported
            return null;
    }
};

export default ResultVisuals;
